/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedHeadMetaTags_node = {
    readonly photos: ReadonlyArray<{
        readonly versions: ReadonlyArray<{
            readonly webPath: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "SharedHeadMetaTags_node";
};
export type SharedHeadMetaTags_node$data = SharedHeadMetaTags_node;
export type SharedHeadMetaTags_node$key = {
    readonly " $data"?: SharedHeadMetaTags_node$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedHeadMetaTags_node">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedHeadMetaTags_node",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "photos",
      "storageKey": "photos(limit:1)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "versions",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "webPath",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '427b68d071a2bd5476c63841de58a2ee';
export default node;
